// src/components/clients/ClientMerge.js
import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import axios from "axios";
import { toast } from "../../helpers/utility";
import parsePhoneNumber from "libphonenumber-js";  // ← IMPORT THIS
import { MERGE_CLIENT } from "../../api/constants";
import { FETCH_CLIENTS } from "../../api/constants";
import moment from "moment";

export default function ClientMerge() {
  const [clients, setClients] = useState([]);
  const [masterId, setMasterId] = useState("");
  const [mergeIds, setMergeIds] = useState([]);
  const [stats, setStats] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);

  // search inputs & dropdown visibility
  const [masterInput, setMasterInput] = useState("");
  const [showMasterList, setShowMasterList] = useState(false);
  const [mergeInput, setMergeInput] = useState("");
  const [showMergeList, setShowMergeList] = useState(false);

  const masterRef = useRef();
  const mergeRef = useRef();

  // load all clients once
  useEffect(() => {
    axios
      .get(FETCH_CLIENTS)
      .then(res => setClients(res.data.data.clients))
      .catch(() => toast("Failed to load clients", "error"));
  }, []);

  // close dropdowns if clicked outside
  useEffect(() => {
    function handleClickOutside(e) {
      if (masterRef.current && !masterRef.current.contains(e.target)) {
        setShowMasterList(false);
      }
      if (mergeRef.current && !mergeRef.current.contains(e.target)) {
        setShowMergeList(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // helper to join first+last
  const fullName = c => `${c.firstName || ""} ${c.lastName || ""}`.trim();
  const labelWithDob = c => {
    const name = fullName(c);
    const dob = c.dob ? moment(c.dob).format("YYYY-MM-DD") : "Unknown DOB";
    return `${name} (${dob})`;
  };

  // only those with any name
  const named = clients.filter(c => fullName(c).length > 0);

  // sorted masters / non-masters
  const masters = named
    .filter(c => c.isMaster)
    .sort((a, b) => fullName(a).localeCompare(fullName(b)));
  const nonMasters = named
    .filter(c => !c.isMaster)
    .sort((a, b) => fullName(a).localeCompare(fullName(b)));

  // filter lists as you type
  const filteredMasters = masters.filter(c =>
    fullName(c).toLowerCase().includes(masterInput.toLowerCase())
  );
  const filteredNonMasters = nonMasters.filter(c =>
    fullName(c).toLowerCase().includes(mergeInput.toLowerCase())
  );

  // display names
/*   const masterName =
    fullName(masters.find(m => m.id === masterId) || {}) || "–";
  const mergeNames = nonMasters
    .filter(c => mergeIds.includes(c.id))
    .map(fullName)
    .join(", "); */

    // display labels with DOB 

  const masterName =
    labelWithDob(masters.find(m => m.id === masterId) || {}) || "–";
  const mergeNames = nonMasters
    .filter(c => mergeIds.includes(c.id))
    .map(labelWithDob)
    .join(", ");


  // API call
  const doMerge = async () => {
    try {
      const { data } = await axios.post(
        MERGE_CLIENT,
        { masterId, mergeIds }
      );
      setStats(data.stats);
      toast("✔ Merge complete!", "success");
      // refresh
      const r = await axios.get(FETCH_CLIENTS);
      setClients(r.data.data.clients);
      setMasterId("");
      setMergeIds([]);
      setMasterInput("");
      setMergeInput("");
    } catch (err) {
      toast(err.response?.data?.message || "Merge failed", "error");
    } finally {
      setShowConfirm(false);
    }
  };

  // render a list—name plus `(DOB • phone • alias)` if available
  const renderItem = (c, onClick, checked) => (
    <li
      key={c.id}
      className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
      style={{ cursor: "pointer" }}
      onClick={onClick}
    >
      <div>
        {fullName(c)}{" "}
        <small className="text-muted">
          (DOB: {c.dob?.split("T")[0] || "–"}
          {c.phone
            ? ` • Phone: ${parsePhoneNumber(c.phone)?.formatNational() || c.phone}`
            : ""}
          {c.alias1 ? ` • alias: ${c.alias1}` : ""}
          )
        </small>
      </div>
      <input type="checkbox" readOnly checked={checked} />
    </li>
  );

  return (
    <div className="client-form full-width mt-4" style={{ height: "100%", width: "60%" }}>
      <Form>
        {/* Master selector */}
        <Row
          className="d-flex align-items-center bg-grey pl-2 pt-2 pb-2"
          style={{ position: "relative" }}
          ref={masterRef}
        >
          <strong style={{ fontSize: "18px", padding: "0.35rem 0.5rem" }}>Master Clients ({masters.length})</strong>
          <Col>
            <Form.Control
              size="sm"
              type="text"
              placeholder="Type to search masters…"
              value={masterInput}
              className="form-fields small text-left"
              style={{ fontSize: "12px", padding: "0.35rem 0.5rem" }}
              onFocus={() => setShowMasterList(true)}
              onChange={e => {
                setMasterInput(e.target.value);
                setMasterId("");
                setShowMasterList(true);
              }}
            />
            {showMasterList && filteredMasters.length > 0 && (
              <ul
                className="list-group position-absolute w-100"
                style={{ zIndex: 1000, maxHeight: 400, overflowY: "auto" }}
              >
                {filteredMasters.map(c =>
                  renderItem(
                    c,
                    () => {
                      setMasterId(c.id);
                      setMasterInput(fullName(c));
                      setShowMasterList(false);
                    },
                    c.id === masterId
                  )
                )}
              </ul>
            )}
          </Col>
        </Row>

        {/* Non-master multi-select */}
        <Row
          className="d-flex align-items-center pt-2 pb-2"
          style={{ position: "relative" }}
          ref={mergeRef}
        >
          <strong style={{ fontSize: "18px", padding: "0.35rem 0.5rem" }}>Clients to Merge ({nonMasters.length})</strong>
          <Col>
            <Form.Control
              size="sm"
              type="text"
              placeholder="Type to search clients…"
              value={mergeInput}
              className="form-fields text-left"
              style={{ fontSize: "18px", padding: "0.35rem 0.5rem" }}
              onFocus={() => setShowMergeList(true)}
              onChange={e => {
                setMergeInput(e.target.value);
                setShowMergeList(true);
              }}
            />
            {showMergeList && filteredNonMasters.length > 0 && (
              <div >
              <ul
                className="list-group position-absolute w-100"
                style={{ zIndex: 1000, maxHeight: 400, overflowY: "auto", postion: "relative" }}
              >
                {filteredNonMasters.map(c =>
                  renderItem(
                    c,
                    () =>
                      setMergeIds(ids =>
                        ids.includes(c.id)
                          ? ids.filter(x => x !== c.id)
                          : [...ids, c.id]
                      ),
                    mergeIds.includes(c.id)
                  )
                )}
                {/* ↓ Done button to close multi-select dropdown */}
                <li className="list-group-item text-center" 
                style={{ zIndex: 1001, position: "sticky", bottom: 0,  }}
                ></li>
                <Button
                variant="secondary"
                size="sm"
                onClick={() => setShowMergeList(false)}>Done</Button>
              </ul>
              </div>
            )}
            {mergeIds.length > 0 && (
              <div className="mt-1 medium text-muted">
                Selected: {mergeNames}
              </div>
            )}
          </Col>
        </Row>

        {/* Merge button */}
        <div className="btn-sec full-width text-right form-btn">
          <Button style={{ fontSize: "18px", padding: "0.35rem 0.5rem" }}
            variant="primary"
            className="main-btn default-btn save-btn"
            onClick={() => {
              if (!masterId || mergeIds.length === 0) {
                toast("Select a master and at least one client", "error");
              } else {
                setShowConfirm(true);
              }
            }}
          >
            Merge Clients
          </Button>
        </div>
      </Form>

      {/* Confirmation Modal */}
      <Modal show={showConfirm} onHide={() => setShowConfirm(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: "24px", padding: "0.35rem 0.5rem" }}>Confirm Merge</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Are you sure you want to merge{" "}
            <strong>{mergeNames || "–"}</strong> into{" "}
            <strong>{masterName}</strong>?
          </p>
          <p>This cannot be undone.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button style={{ fontSize: "18px", padding: "0.35rem 0.5rem" }} variant="secondary" onClick={() => setShowConfirm(false)}>
            Cancel
          </Button>
          <Button style={{ fontSize: "18px", padding: "0.35rem 0.5rem" }} variant="danger" onClick={doMerge}>
            Yes, merge now
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
